import * as Types from '../types';

/**
 * React Query `placeholderData` for the paged test lists: keep showing the
 * previous page while the next one loads, so the table and pager stay put —
 * but never carry a list over from another organization.
 */
export const keepPageWithinOrg =
  (params?: Types.IApi.List.Params) =>
  (
    previous: Types.IQuery.List | undefined,
    previousQuery: { queryKey: readonly unknown[] } | undefined,
  ): Types.IQuery.List | undefined => {
    if (!previous || !previousQuery) return undefined;
    const previousParams = JSON.parse(String(previousQuery.queryKey[2] ?? '{}')) as Types.IApi.List.Params;
    return previousParams.orgId === params?.orgId ? previous : undefined;
  };
